import React from 'react';
import clsx from 'clsx';

interface Props {
  checked: boolean;
  onChange: (x: boolean) => void;
  disabled: boolean;
  id: string;
}

export const FeatureCheckbox = ({ checked, onChange, disabled, id }: Props) => {
  const handleCheckboxChange = ({ target: { checked: checkboxState } }: React.ChangeEvent<HTMLInputElement>) =>
    onChange(checkboxState);
  const isDisabled = checked === null || disabled;
  return (
    <div className="h-12 flex items-center space-x-3">
      <label className="flex justify-start items-start" htmlFor={id}>
        <div
          className={clsx(
            'field-with-icons rounded w-5 h-5 flex flex-shrink-0 justify-center items-center relative disabled',
            isDisabled && 'opacity-40 cursor-not-allowed'
          )}
        >
          <input
            disabled={isDisabled}
            type="checkbox"
            className="hidden"
            onChange={handleCheckboxChange}
            checked={checked}
            id={id}
          />
          <svg
            viewBox="0 0 20 20"
            className={clsx(
              `fill-${checked && disabled ? 'gray-400' : 'current'} w-3 h-3 text-primary-500 pointer-events-none`,
              !checked && 'hidden'
            )}
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        </div>
      </label>
    </div>
  );
};
